import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../app/providers/AuthProvider';
import { COLORS } from '../../../core/constants/colors';

export const PurpleNavBar: React.FC = () => {
  const { authState, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  const getUserInitial = () => {
    return authState.user?.full_name?.charAt(0).toUpperCase() || authState.user?.email?.charAt(0).toUpperCase() || 'U';
  };

  const isActive = (path: string) => {
    if (path === '/dashboard') {
      return location.pathname === path || location.pathname === '/dashboard/query';
    }
    return location.pathname.startsWith(path);
  };

  const isAdmin = authState.user?.email?.endsWith('@admin.com') || location.pathname.startsWith('/admin');

  return (
    <div style={{ backgroundColor: COLORS.user.primary }}>
      <div className="border-b" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate('/dashboard')}>
              <img
                src="/new_logo+white.png"
                alt="Portfolio Indexing System"
                className="h-16"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>

            {/* Navigation Links */}
            <div className="hidden md:flex items-center gap-8">
              {location.pathname.startsWith('/admin') ? (
                <>
                  <button
                    onClick={() => navigate('/admin')}
                    className={`text-white font-medium pb-4 ${location.pathname === '/admin' ? 'border-b-2' : 'hover:opacity-80'}`}
                    style={{
                      borderColor: location.pathname === '/admin' ? '#FF5E2E' : 'transparent',
                      opacity: location.pathname === '/admin' ? 1 : 0.7,
                    }}
                  >
                    Admin Dashboard
                  </button>
                  <button
                    onClick={() => navigate('/admin/companies')}
                    className={`text-white font-medium pb-4 ${location.pathname.startsWith('/admin/companies') ? 'border-b-2' : 'hover:opacity-80'}`}
                    style={{
                      borderColor: location.pathname.startsWith('/admin/companies') ? '#FF5E2E' : 'transparent',
                      opacity: location.pathname.startsWith('/admin/companies') ? 1 : 0.7,
                    }}
                  >
                    Companies
                  </button>
                  <button
                    onClick={() => navigate('/admin/documents')}
                    className={`text-white font-medium pb-4 ${location.pathname.startsWith('/admin/documents') ? 'border-b-2' : 'hover:opacity-80'}`}
                    style={{
                      borderColor: location.pathname.startsWith('/admin/documents') ? '#FF5E2E' : 'transparent',
                      opacity: location.pathname.startsWith('/admin/documents') ? 1 : 0.7,
                    }}
                  >
                    Documents
                  </button>
                  <button
                    onClick={() => navigate('/admin/users')}
                    className={`text-white font-medium pb-4 ${location.pathname.startsWith('/admin/users') ? 'border-b-2' : 'hover:opacity-80'}`}
                    style={{
                      borderColor: location.pathname.startsWith('/admin/users') ? '#FF5E2E' : 'transparent',
                      opacity: location.pathname.startsWith('/admin/users') ? 1 : 0.7,
                    }}
                  >
                    Users
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={() => navigate('/dashboard')}
                    className={`text-white font-medium pb-4 ${isActive('/dashboard') ? 'border-b-2' : 'hover:opacity-80'}`}
                    style={{
                      borderColor: isActive('/dashboard') ? '#FF5E2E' : 'transparent',
                      opacity: isActive('/dashboard') ? 1 : 0.7,
                    }}
                  >
                    Overview
                  </button>
                  <button
                    onClick={() => navigate('/dashboard/companies')}
                    className={`text-white font-medium pb-4 ${isActive('/dashboard/companies') && !isActive('/dashboard') ? 'border-b-2' : 'hover:opacity-80'}`}
                    style={{
                      borderColor: isActive('/dashboard/companies') && !isActive('/dashboard') ? '#FF5E2E' : 'transparent',
                      opacity: isActive('/dashboard/companies') && !isActive('/dashboard') ? 1 : 0.7,
                    }}
                  >
                    Companies
                  </button>
                  <button
                    onClick={() => navigate('/dashboard/history')}
                    className={`text-white font-medium pb-4 ${isActive('/dashboard/history') ? 'border-b-2' : 'hover:opacity-80'}`}
                    style={{
                      borderColor: isActive('/dashboard/history') ? '#FF5E2E' : 'transparent',
                      opacity: isActive('/dashboard/history') ? 1 : 0.7,
                    }}
                  >
                    History
                  </button>
                  <button
                    onClick={() => navigate('/dashboard/billing')}
                    className={`text-white font-medium pb-4 ${isActive('/dashboard/billing') ? 'border-b-2' : 'hover:opacity-80'}`}
                    style={{
                      borderColor: isActive('/dashboard/billing') ? '#FF5E2E' : 'transparent',
                      opacity: isActive('/dashboard/billing') ? 1 : 0.7,
                    }}
                  >
                    Billing
                  </button>
                  <div className="relative">
                  <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setOpenDropdown(openDropdown === 'enrichment' ? null : 'enrichment');
                      }}
                      className="text-white font-medium pb-4 hover:opacity-80 flex items-center gap-2"
                    style={{
                        borderBottom: isActive('/dashboard/enrichment') || location.pathname.startsWith('/dashboard/web-enrichment') || location.pathname.startsWith('/dashboard/linkedin-enrichment')
                          ? '2px solid #FF5E2E'
                          : '2px solid transparent',
                        opacity: isActive('/dashboard/enrichment') || location.pathname.startsWith('/dashboard/web-enrichment') || location.pathname.startsWith('/dashboard/linkedin-enrichment') ? 1 : 0.7,
                    }}
                  >
                    Enrichment
                      <svg
                        className={`w-4 h-4 transition-transform ${openDropdown === 'enrichment' ? 'rotate-180' : ''}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                    {openDropdown === 'enrichment' && (
                      <>
                        <div
                          className="fixed inset-0 z-30"
                          onClick={() => setOpenDropdown(null)}
                        />
                        <div
                          className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-lg z-40 border"
                          style={{ borderColor: 'rgba(0,0,0,0.05)' }}
                        >
                          {[
                            { name: 'Document Enrichment', path: '/dashboard/enrichment' },
                            { name: 'Web Enrichment', path: '/dashboard/web-enrichment' },
                            { name: 'LinkedIn Enrichment', path: '/dashboard/linkedin-enrichment' },
                          ].map((item) => {
                            const active = location.pathname.startsWith(item.path);
                            return (
                              <button
                                key={item.path}
                                type="button"
                                onClick={() => {
                                  navigate(item.path);
                                  setOpenDropdown(null);
                                }}
                                className={`w-full text-left px-4 py-2 text-sm transition-all ${
                                  active ? 'text-white' : 'hover:bg-gray-50'
                                }`}
                                style={{
                                  backgroundColor: active ? COLORS.user.primary : 'transparent',
                                  color: active ? '#FFFFFF' : COLORS.primary.persianIndigo,
                                }}
                              >
                                {item.name}
                  </button>
                            );
                          })}
                        </div>
                      </>
                    )}
                  </div>
                  {isAdmin && (
                    <button
                      onClick={() => navigate('/admin')}
                      className={`text-white font-medium pb-4 ${location.pathname.startsWith('/admin') ? 'border-b-2' : 'hover:opacity-80'}`}
                      style={{
                        borderColor: location.pathname.startsWith('/admin') ? '#FF5E2E' : 'transparent',
                        opacity: location.pathname.startsWith('/admin') ? 1 : 0.7,
                      }}
                    >
                      Admin
                    </button>
                  )}
                </>
              )}
            </div>

            {/* Right Icons */}
            <div className="flex items-center gap-4">
              <button className="text-white opacity-70 hover:opacity-100">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>
              <button className="text-white opacity-70 hover:opacity-100">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </button>
              <button className="text-white opacity-70 hover:opacity-100 relative">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                </svg>
              </button>
              <div className="relative">
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="w-9 h-9 rounded-full flex items-center justify-center text-white font-semibold"
                  style={{ backgroundColor: COLORS.user.queryButton }}
                >
                  {getUserInitial()}
                </button>
                {showUserMenu && (
                  <>
                    <div className="fixed inset-0 z-40" onClick={() => setShowUserMenu(false)} />
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
                      <button
                        onClick={logout}
                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      >
                        Logout
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

